import { createContext, useContext } from "react";
import { Layer } from "../../types/Layer";

export interface LayerContextType {
  layers: Layer[];
}

const LayerContext = createContext<LayerContextType | undefined>(undefined);

const useLayerContext = () => {
  const context = useContext(LayerContext);

  if (context === undefined) {
    throw new Error("useLayerContext was used outside of its Provider");
  }

  return context;
};

export { LayerContext, useLayerContext };
